<p-panel
  iconPos="left"
  [toggleable]="collapsible"
  toggler="header"
  [collapsed]="collapsed"
  (onBeforeToggle)="onBeforeToggle($event)"
  [ngClass]="{ collapsed: collapsed, tight: tight }"
>
  <ng-template pTemplate="header">
    <div class="header-content">
      <h3 class="heading">{{ title }}</h3>
      <div class="header-extra-content">{{ headerContent }}</div>
    </div>
  </ng-template>
  <div class="body-content" [style.max-height]="contentMaxHeight">
    <ng-content></ng-content>
  </div>
</p-panel>
